import { useCompanies } from '@adsk/alloy-provider';

interface CompanyData {
  memberGroupId?: string;
  isLoading: boolean;
  name?: string;
}

export default function useCompaniesData(ids: string[]): CompanyData[] {
  const { data: companies, loading } = useCompanies();
  let companiesData: CompanyData[] = [];
  ids.forEach((id) => {
    const company = companies.find((company) => company.memberGroupId === id);
    if (!company) {
      companiesData = [...companiesData, { isLoading: loading }];
    } else {
      companiesData = [
        ...companiesData,
        {
          name: company.name,
          memberGroupId: company.memberGroupId,
          isLoading: false,
        },
      ];
    }
  });
  return companiesData;
}
